import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('promo');
const GET_PROMO = define('GET_PROMO', true);
const GET_ARC_PROMO = define('GET_ARC_PROMO', true);
const ARCHIVE_PROMO = define('ARCHIVE_PROMO', true);
const DELETE_PROMO = define('DELETE_PROMO', true);
const UPDATE_PROMO = define('UPDATE_PROMO', true);
const CREATE_PROMO = define('CREATE_PROMO', true);

const initialState = {
  promos: [],
  archived: [],
  isLoading: true,
  isLoadingArchived: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PROMO.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_PROMO.RESOLVED:
      return {
        ...state,
        isLoading: false,
        promos: action.data
      };
    case GET_PROMO.REJECTED:
      return {
        ...state,
        isLoading: false
      };
    case GET_ARC_PROMO.PENDING:
      return {
        ...state,
        isLoadingArchived: true,
      };
    case GET_ARC_PROMO.RESOLVED:
      return {
        ...state,
        isLoadingArchived: false,
        archived: action.data
      };
    case GET_ARC_PROMO.REJECTED:
      return {
        ...state,
        isLoadingArchived: false
      };
    default: return state;
  }
};

export const actions = {
  getPromo: () => ({
    type: GET_PROMO,
    promise: api.get('/redeems'),
    error: 'Unable to load promo code'
  }),
  getArchivedPromo: () => ({
    type: GET_ARC_PROMO,
    promise: api.get('/redeems/archive'),
    error: 'Unable to load archived promo code'
  }),
  archivePromo: id => ({
    type: ARCHIVE_PROMO,
    promise: api.post(`/redeems/${id}/archive`)
  }),
  deletePromo: id => ({
    type: DELETE_PROMO,
    promise: api.delete(`/redeems/${id}`)
  }),
  updatePromo: (id, data) => ({
    type: UPDATE_PROMO,
    promise: api.put(`/redeems/${id}`, data),
    success: 'Promo code has been updated',
    error: 'Unable to update promo code'
  }),
  createPromo: data => ({
    type: CREATE_PROMO,
    promise: api.post('/redeems', data),
    success: 'Promo code has been created',
    error: 'Unable to create promo code'
  })
  // createSection: data => ({
  //   type: CREATE_SECTION,
  //   promise: api.post('/topics', data),
  //   success: 'Section has been created',
  //   error: 'Unable to create new section'
  // }),
  // editSection: (id, data) => ({
  //   type: EDIT_SECTION,
  //   promise: api.put(`/topics/${id}`, data),
  //   success: 'Section has been edited',
  //   error: 'Unable to edited section'
  // }),
};




// WEBPACK FOOTER //
// ./src/ducks/promo.js